<div>
  <div id="banner">
    <h1>OPUS Chatbot</h1>
  </div>
  <div id="webchat" role="main"></div>
</div>
    